import { cScene } from "../creator/cScene";


export class LoaderDisplay extends Phaser.GameObjects.Container {

  private glow: Phaser.GameObjects.Sprite
  private shine: Phaser.GameObjects.Sprite
  private pct: Phaser.GameObjects.Text
  private info: Phaser.GameObjects.Text

  
  constructor(sc){
    super(sc,960,450);

    this.glow = new Phaser.GameObjects.Sprite(this.scene,0,0,'interface_glow');
    this.add(this.glow);

    this.shine = new Phaser.GameObjects.Sprite(this.scene,0,0,'interface_shine');
    this.add(this.shine);


    var style = (sc as cScene).getStyle('btn');
    style.fixedWidth = 200;
    style.fontSize='60px'

    this.pct = new Phaser.GameObjects.Text(this.scene,-100,-40,'0',style)
    this.add(this.pct)


    var style2 = {...style}
    style2.fontSize = '20px'

    this.info = new Phaser.GameObjects.Text(this.scene,-100,40,'Daten werden\ngeladen',style2)
    this.add(this.info)

    // this.scene.tweens.add({
    //   targets:[this.glow],
    //   scale:1,
    //   alpha:1,
    //   duration:400
    // })

  }
  
  public set progress(v:number){
    if (!v) v = 0;
    v = v > 1 ? 1 : v;
    this.pct.setText(Math.round(v*100)+'');
  }

  public close(){
    //this.destroy()

    this.pct.destroy();
    this.info.destroy();
    this.scene.tweens.add({
      targets:[this.glow, this.shine],
      scale:0.5,
      alpha:0,
      duration:400
    })

  }

}

